import { render, staticRenderFns } from "./PointStatement.vue?vue&type=template&id=4f08539c&scoped=true&"
import script from "./PointStatement.vue?vue&type=script&lang=js&"
export * from "./PointStatement.vue?vue&type=script&lang=js&"
import style0 from "./PointStatement.vue?vue&type=style&index=0&id=4f08539c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f08539c",
  null
  
)

export default component.exports